import { Component } from '@angular/core';
import { AppShellComponent } from '@shared/layout/app-shell/app-shell.component';

/** Composant racine : délègue tout au shell responsive. */
@Component({
  selector: 'app-root',
  imports: [AppShellComponent],
  template: '<app-shell />',
})
export class AppComponent {}
